import React from 'react'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'
import { OwnerAssignmentButton as ReusableOwnerAssignmentButton } from '../../../components/Reusable/Buttons'
import { ControlMutator } from './ControlListItem.constants'

export const OwnerAssignmentButton = ({
  control,
  mutate,
  id, // Used for Risks and future models
}: {
  control: Control.AsObject
  mutate: ControlMutator
  id?: string
}): JSX.Element => {
  const canUpdateOwner = useCanPerformAction<Control.AsObject>(
    CAPABILITY.CAN_UPDATE_CONTROL_OWNER,
    control,
  )
  return (
    <ReusableOwnerAssignmentButton
      modelId={id || control.id}
      email={control.ownerEmail}
      isDisabled={control.isDismissed || !canUpdateOwner}
      onUpdate={mutate}
      modelType={MODEL_TYPE.CONTROL}
    />
  )
}
